import { Button, ButtonProps, WrapItem } from '@chakra-ui/react';
import IconArrowRight from 'assets/icons/icon-arrow-right.svg?react';
import { NavLink, NavLinkProps } from 'react-router-dom';
import { useStyles } from './Navigator';

export default function NavigatorItem({icon, ...props}: ButtonProps & Partial<NavLinkProps> & { icon?: React.ReactElement }) {
  const styles = useStyles();
  if (props.to)
    props.as = NavLink;

  return (
    <WrapItem __css={styles.navigatorItem}>
      <Button
        variant="ghost" 
        leftIcon={icon}
        rightIcon={<IconArrowRight />}
        {...props} 
      />
    </WrapItem>
  )
}
